'use client';

import { Box, VStack } from '@terra/ui-styled-system';
import { Badge } from '../../../../components/badge';
import { MetaDefault } from '../../../../components/typography';
import { clientFacingToolName } from '../../components/client-facing-tool-name';
import { useTranslations } from 'next-intl';
import {
  parseLoadedToolNames,
  summarizeSelectedToolNames,
} from '../utils/load-tools-output';

type LoadToolsResultCardProps = {
  output: string;
};

export function LoadToolsResultCard({ output }: LoadToolsResultCardProps) {
  const t = useTranslations('designSystem.chat');
  const toolNames = parseLoadedToolNames(output);
  const labels = toolNames.map(clientFacingToolName);
  const summaryLine = summarizeSelectedToolNames({
    args: { tools: labels },
  });

  if (toolNames.length === 0 || !summaryLine) {
    return <MetaDefault color="fg.muted">{t('loadedTools')}</MetaDefault>;
  }

  return (
    <VStack alignItems="flex-start" gap={2} width="100%">
      <MetaDefault color="fg.muted">
        {t('loadedToolSummary', { summary: summaryLine })}
      </MetaDefault>
      <Box display="flex" flexWrap="wrap" gap={1}>
        {toolNames.map((name, index) => (
          <Badge key={name} variant="outline" size="xs">
            {labels[index]}
          </Badge>
        ))}
      </Box>
    </VStack>
  );
}
